module.exports = __webpack_public_path__ + "public/Icons/manage_categories.svg?7ce2059e";